if (!customElements.get('age-verifier')) {
  customElements.define(
    'age-verifier',
    class AgeVerifier extends ModalElement {
      constructor() {
        super();
    
        this.init();
      }
    
      get shouldLock() {
        return true;
      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return 1;
      }
    
      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30;
      }
    
      get cookieName() {
        return 'concept:age-verifier';
      }

      // No swipe to dismiss: only the confirm button lets a visitor in
      get gesture() {
        return null;
      }

      get confirmButton() {
        return this.querySelector('[data-age-confirm]');
      }

      // Without a confirm button (empty label) nobody could get in, so the
      // gate then closes the way the theme closes it
      get locked() {
        return !Shopify.designMode && !!this.confirmButton;
      }

      connectedCallback() {
        super.connectedCallback();

        // The newsletter popup sits under the gate and takes the keyboard
        // focus when it opens. Keep the focus on the gate while it is up,
        // and hand it to the popup once the visitor is in.
        this.on(document, this.events.afterShow, (event) => {
          if (this.open && event.target !== this) theme.a11y.trapFocus(this, this.focusElement);
        });
      }

      onButtonClick(event) {
        if (this.locked && !event.currentTarget.hasAttribute('data-age-confirm')) {
          event.preventDefault();
          return;
        }

        this.confirmed = true;
        super.onButtonClick(event);
      }

      // Escape, a click on the overlay and other modals closing everything
      // all end up here, and none of them should set the cookie
      hide() {
        if (this.locked && !this.confirmed) return;

        return super.hide();
      }

      init() {
        if (this.testMode || !this.getCookie(this.cookieName)) {
          this.load(this.delay);
        }
      }
    
      load(delay) {
        if (Shopify.designMode) return;
    
        setTimeout(() => this.show(), delay * 1000);
      }
    
      afterShow() {
        super.afterShow();
        this.classList.add('show-image');
      }
    
      afterHide() {
        super.afterHide();
        this.classList.remove('show-image');

        const waiting = document.querySelector('.x-modal[open]:not(#AgeVerifier)');
        if (waiting) setTimeout(() => theme.a11y.trapFocus(waiting, waiting.focusElement));
    
        // Remove a cookie in case it was set in test mode
        if (this.testMode) {
          this.removeCookie(this.cookieName);
          return;
        }
    
        this.setCookie(this.cookieName, this.expiry);
      }
    
      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }
    
      setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
      }
    
      removeCookie(name) {
        document.cookie = `${name}=; max-age=0`;
      }
    }
  );
}
